import './App.css';
import React from "react";
import Login from './login/Login';
import VerifyCode from './login/VerifyCode';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './home/Home';
import Header from './components/Header';
import Register from './register/Register';
import api from './util/api'
import Splash from './splash/Splash';
import Me from './me/Me';
import SearchUsers from './searchusers/SearchUsers';
import Profile from './profile/Profile';
import TermsOfService from './home/Terms';
import PrivacyPolicy from './home/Privacy';
import NotFound from './notfound/NotFound';
import Forgot from './forgot/Forgot';
import Reset from './reset/Reset';
import Notifications from './notifications/Notifications';
import Onboarding from './onboarding/Onboarding';
import { AuthProvider } from './context/AuthContext';

const App = () => {

  return (
    <AuthProvider>
      <div>

        <Routes>
          <Route path="/" element={<Splash api={api} />} />
          <Route path="/login" element={<Login api={api} />} />
          <Route path="/login/verify" element={<VerifyCode api={api} />} />
          {/* REMOVED: <Route path="/register" element={<Register api={api} />} /> */}
          <Route path="/onboarding" element={<Onboarding api={api} />} />
          <Route path="/home" element={<Home api={api} />} />
          <Route path="/me" element={<Me api={api} />} />
          <Route path="/users/search" element={<SearchUsers api={api} />} />
          <Route path="/user/:username" element={<Profile api={api} />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/forgot" element={<Forgot api={api} />} />
          <Route path="/reset" element={<Reset api={api} />} />
          <Route path="/notifications" element={<Notifications api={api} />} />
          <Route path="/*" element={<NotFound api={api} />} />
        </Routes>
      </div>
    </AuthProvider>
  );
};

export default App;
